import React, { useContext } from 'react';
import {useNavigate} from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import VisibilityIcon from '@mui/icons-material/Visibility';


import DivSpinner from "../../../components/divSpinner";
import { Context } from '../Provider';
import ColumnSort from "./ColumnSort";

const TableHeader = () => (
    <TableHead>
        <TableRow className='remedial-table-row'>
            {[
                'Tradesperson',
                'Contact Number',
                'Email',
                'Customer Ratings',
                'Pushed Jobs',
                'Accepted Jobs',
                'Total Ratings',
                ''
            ].map((text, index) => (
                <TableCell 
                    key={index}
                    className ="text-uppercase text-secondary text-sm font-weight-bolder opacity-7">
                    <ColumnSort sortKeyName={text} />
                </TableCell>
            ))}
        </TableRow>
    </TableHead>
);

const TableTuple = ({ ftm }) => {
    let navigate = useNavigate();
    const {
        ftm_id,
        ftm_profile_image_path,
        ftm_forename,
        ftm_surname,
        ftm_contact_number,
        ftm_email,
        ftm_createdAt,
        ftm_customer_ratings,
        ftm_pushed_jobs,
        ftm_accepted_jobs,
        ftm_total_ratings
    } = ftm;

    return (
        <TableRow>
            <TableCell>
                <div className="d-flex px-2 py-1">
                    <img
                        src={ftm_profile_image_path || "/assets/img/lock_user.png"}
                        className="avatar avatar-sm me-3 border-radius-lg"
                        alt="profile"
                    />
                    <div className="d-flex flex-column justify-content-center">
                        <h6 className="mb-0 text-sm">
                            {ftm_forename} {ftm_surname}
                        </h6>
                        <p className="text-xs text-secondary mb-0">Created {ftm_createdAt}</p>
                    </div>
                </div>
            </TableCell>
            <TableCell className="text-secondary text-sm font-weight-bold">{ftm_contact_number}</TableCell>
            <TableCell className="text-secondary text-sm font-weight-bold">{ftm_email}</TableCell>
            <TableCell className="text-secondary text-sm font-weight-bold" align="center">{ftm_customer_ratings}</TableCell>
            <TableCell className="text-secondary text-sm font-weight-bold" align="center">{ftm_pushed_jobs}</TableCell>
            <TableCell className="text-secondary text-sm font-weight-bold" align="center">{ftm_accepted_jobs}</TableCell>
            <TableCell className="text-secondary text-sm font-weight-bold" align="center">{ftm_total_ratings}</TableCell>
            <TableCell className="align-middle">
                <VisibilityIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate(`/ftm/view/${ftm_id}`)}
                />
            </TableCell>
        </TableRow>
    );
};

const NoDataAvailable = () => (
    <TableRow>
        <TableCell colSpan={8} align="center">Sorry, no data found!</TableCell>
    </TableRow>
);

const TableView = () => {
    let context = useContext(Context);

    return (
        <>
            {context.state.is_loading ? (
                <div style={{height : `${window.innerHeight-387}px`}}>
                    <DivSpinner/>
                </div>
            ) : (
                <div className="table-responsive p-0 m-3">
                    <TableContainer component={Paper}>
                        <Table aria-label="collapsible table" size={'small'}>
                            <TableHeader />
                            <TableBody>
                            {context.state.ftms_ratings.length > 0 ? (
                                <>
                                    {context.state.ftms_ratings.map((ftm, index) => (
                                        <TableTuple
                                            key={index}
                                            ftm={ftm}
                                        />
                                    ))}
                                </>
                            ) : (
                                <NoDataAvailable/>
                            )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            )}
        </>
    );
}

export default TableView;